import {Stack, Typography} from "@mui/material";
import {appStyles} from "../../../../AppStyles.ts";

function UXResourceResearchPanel() {
    return (
        <Stack sx={appStyles.defaultPanelContainer} direction="column" padding={1} width="100%">
            <Stack direction="row" padding={1} justifyContent="center">
                <Typography sx={appStyles.panelSectionTitle}>Research</Typography>
            </Stack>
        </Stack>
    );
}

export default UXResourceResearchPanel;
